import { BigNumber } from 'bignumber.js';
import SmartContract from './contract';

const wei = 10 ** 18;

class BillboardsContract {
  constructor() {
    this.contract = new SmartContract(1, 'n22JY9xPACsKnzweL2aRqohpJsxZHerGJDM');
  }

  async call(value, func, args) {
    const result = await this.contract.call(value, func, args);
    return JSON.parse(result);
  }

  async check(func, args) {
    const result = await this.contract.check(func, args);
    return JSON.parse(result);
  }

  async bid(value, text) {
    return this.call(value, 'bid', [text]);
  }

  async acceptBid() {
    return this.call(0, 'acceptBid', []);
  }

  async renew() {
    const state = await this.check('getState', []);
    return this.call(new BigNumber(state.rentPrice).mul('1.1').div(wei).toString(), 'renew', []);
  }

  async getState() {
    const state = await this.check('getState', []);
    if (state.rentPrice) {
      state.rentPrice = new BigNumber(state.rentPrice).div(wei).toFixed(8);
    }
    if (state.bid && state.bid.value) {
      state.bid.value = new BigNumber(state.bid.value).div(wei).toFixed(8);
    }
    return state;
  }
}

export default BillboardsContract;



// WEBPACK FOOTER //
// ./src/lib/billboards-contract.js